import { render, staticRenderFns } from "./CallCenterRecall.vue?vue&type=template&id=571d9231&"
import script from "./CallCenterRecall.vue?vue&type=script&lang=ts&"
export * from "./CallCenterRecall.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports